const style = {
  progressWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: 'inherit',
    marginLeft: '8px',
    '@media (max-width: 768px)': {
      width: '50%',
    },
  },
  value: {
    minWidth: 35,
    color: '#5297FF',
    fontSize: '12px',
  },
  progress: {
    height: '14px',
    border: '1px solid',
    borderRadius: '7px',
    backgroundColor: '#FFFFFF',
    marginLeft: '8px',

    '& .MuiLinearProgress-bar': {
      borderRadius: '7px',
      backgroundColor: '#5297FF',
    },
  },
  valueV2: {
    minWidth: 35,
    color: '#2E3860',
    fontSize: '14px',
    fontWeight: 700,
    whiteSpace: 'nowrap',
    '@media (max-width: 768px)': {
      minWidth: 'unset',
      marginRight: 5,
      whiteSpace: 'nowrap',
    },
  },
  progressV2: {
    height: '8px',
    border: '0px',
    borderRadius: '7px',
    backgroundColor: '#E2E2FC',
    marginLeft: '20px',
    '@media (max-width: 768px)': {
      marginLeft: '0px',
    },
    '& .MuiLinearProgress-bar': {
      borderRadius: '7px',
      backgroundColor: '#2E3860',
    },
  },
}

export default style
